import { PesTest, Result, TrainedIndicator } from "generated/graphql";
import { PartialDeep } from "type-fest";
import {
  getIndexForValue,
  getIndicatorIndices,
  indicatorNameMatches,
  normalizeIndicatorName,
} from "~/components/dashboard/single-result/indices";

type PdfResult = PartialDeep<Result, { recurseIntoArrays: true }>;

export { normalizeIndicatorName };
export const IndicatorNameMatches = indicatorNameMatches;

// `TrainedIndicator.name` resolves to the definition's display name, so select
// indices by the stable indicator-definition name where it was queried.
export const GetIndices = (trainedIndicator: PartialDeep<TrainedIndicator>) =>
  getIndicatorIndices(
    trainedIndicator.indicatorDefinition?.name ?? trainedIndicator.name,
    trainedIndicator.minValue!,
    trainedIndicator.maxValue!
  );

export const GetPESIndex = (
  value: string | number,
  trainedIndicator?: PartialDeep<TrainedIndicator>
) => {
  if (typeof value !== "number" || !trainedIndicator) {
    return null;
  }

  const indices = GetIndices(trainedIndicator);
  return { indices, indexValue: getIndexForValue(indices, value) };
};

export const GetDynamicValue = (
  test: PartialDeep<PesTest, { recurseIntoArrays: true }>,
  indicatorName: string
) => {
  const results = test.results?.nodes ?? [];
  const result = results
    .filter(
      (result): result is PdfResult =>
        Boolean(result) &&
        result?.indicator?.model?.name === test.originalModelName
    )
    .sort((a, b) => {
      // Most recent result first
      if (a.createdAt! > b.createdAt!) {
        return -1;
      }
      if (a.createdAt! < b.createdAt!) {
        return 1;
      }
      return 0;
    })
    .find((r) =>
      IndicatorNameMatches(
        r?.indicator?.indicatorDefinition?.name,
        indicatorName
      )
    );
  const value = result?.value ?? "N/A";
  return { value };
};
